/*
 *
 * Api constants
 *
 */

export const REQUEST_API_KEY = 'app/Api/REQUEST_API_KEY';
export const REQUEST_API_KEY_RESULT = 'app/Api/REQUEST_API_KEY_RESULT';
export const REFRESH_TOKEN = 'app/Api/REFRESH_TOKEN';
export const REQUEST_API_KEY_REFRESH_RESULT = 'app/Api/REQUEST_API_KEY_REFRESH_RESULT';

export const RESET_API_KEY = 'app/Api/RESET_API_KEY';

export const DISABLE_SESSION = 'app/Api/DISABLE_SESSION';

export const VERIFY_API_KEY = 'app/Api/VERIFY_API_KEY';
export const API_KEY_INVALID = 'app/Api/API_KEY_INVALID';
export const API_CALL_RESULT = 'app/Api/API_CALL_RESULT';

export const REQUEST_PASSWORD_RESET = 'app/Api/REQUEST_PASSWORD_RESET';
export const REQUEST_PASSWORD_SET = 'app/Api/REQUEST_PASSWORD_SET';

export const SET_GATE = 'app/Api/SET_GATE';
export const ADD_WORK = 'app/Api/ADD_WORK';
export const REDUCE_WORK = 'app/Api/REDUCE_WORK';
export const API_ERROR = 'app/Api/API_ERROR';
export const CONFIG = 'app/Api/API_ERROR';

export const WARNING = 'app/Api/WARNING';

export const FETCH_APP_CONFIG = 'app/Api/FETCH_APP_CONFIG';
export const UPDATE_APP_CONFIG = 'app/Api/UPDATE_APP_CONFIG';

export const ACCEPT_TERMS_AND_CONDITIONS = 'app/Api/ACCEPT_TERMS_AND_CONDITIONS';
export const ME = 'app/Api/ME';
export const MY_TAGS = 'app/Api/MY_TAGS';
export const SET_AZURE_API_KEY = 'SET_AZURE_API_KEY';
export const SET_AZURE_API_KEY_RESULT = 'SET_AZURE_API_KEY_RESULT';
